import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageGetSlugService } from '../../services';

export const fetchPageGetSlug = createAsyncThunk(
    'pageGetSlug/fetchPageGetSlug',
    async ({ slug }) => {
        if (slug === "hakkimizda" || slug === "about-us") {
            var data = localStorage.getItem('page-about')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-about', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "anasayfa" || slug === "homepage") {
            var data = localStorage.getItem('page-home')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-home', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "hakkimizda" || slug === "about-us") {
            var data = localStorage.getItem('page-about')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-about', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "ucretler" || slug === "wages") {
            var data = localStorage.getItem('page-wages')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-wages', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "indirme" || slug === "download") {
            var data = localStorage.getItem('page-download')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-download', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "iletisim" || slug === "contact") {
            var data = localStorage.getItem('page-contact')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-contact', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "sss" || slug === "faq") {
            var data = localStorage.getItem('page-sss')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-sss', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "is-ortaklarimiz" || slug === "our-bussiness-partners") {
            var data = localStorage.getItem('page-partners')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-services', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "istasyonlar" || slug === "stations") {
            var data = localStorage.getItem('page-stations')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-stations', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "mesafeli-satis-sozlesmesi" || slug === "distance-sales-agreement") {
            var data = localStorage.getItem('page-contract1')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-contract1', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "iptal-ve-iade-kosullari" || slug === "cancellation-and-refund-conditions") {
            var data = localStorage.getItem('page-contract2')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-contract2', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "uyelik-sozlesmesi" || slug === "membership-contract") {
            var data = localStorage.getItem('page-contract3')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-contract3', JSON.stringify(response.result))
            return response.result
        }
        if (slug === "gizlilik-sozlesmesi" || slug === "privacy-policy") {
            var data = localStorage.getItem('page-contract4')
            if (data) {
                return JSON.parse(data)
            }
            const response = await PageGetSlugService(slug)
            localStorage.setItem('page-contract4', JSON.stringify(response.result))
            return response.result
        }
        const response = await PageGetSlugService(slug)
        return response.result;
    }
);

const pageGetSlugSlice = createSlice({
    name: 'pageGetSlug',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageGetSlug.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageGetSlug.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageGetSlug.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageGetSlugSlice.reducer;
